var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_575_7355)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.73907 16.76L3.73774 16.7506L3.73604 16.7411L1.63476 5.07918C1.63257 5.05296 1.63073 5.02925 1.62926 5.00762C1.69942 5.00268 1.79281 5 1.91805 5H16.082C16.207 5 16.3004 5.00255 16.3707 5.00734C16.3692 5.02911 16.3674 5.05297 16.3652 5.07933L14.2636 16.7411L14.2619 16.7505L14.2606 16.76L14.2563 16.7905C14.2156 17.08 14.1895 17.2652 14.1249 17.396C14.099 17.4487 14.078 17.4658 14.067 17.4729C14.0573 17.4792 14.021 17.5001 13.9239 17.5001H4.07574C3.97864 17.5001 3.94239 17.4792 3.93264 17.4729C3.92162 17.4658 3.90071 17.4487 3.87473 17.396C3.81018 17.2652 3.7841 17.08 3.74337 16.7905L3.73907 16.76ZM1.48895 5.0271C1.48893 5.02709 1.48941 5.02691 1.49043 5.02659L1.48895 5.0271ZM16.5129 5.02665C16.5129 5.02666 16.5124 5.0265 16.5114 5.02614L16.5129 5.02665Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.00312,
    y: 8.24971,
    width: 0.50625,
    height: 5.44296,
    rx: 0.253125,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.50625
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.3781,
    y: 8.24971,
    width: 0.50625,
    height: 5.44296,
    rx: 0.253125,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.50625
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_575_7355",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2.5014C0 2.22529 0.223828 2.00146 0.499934 2.00146H17.5001C17.7762 2.00146 18 2.22529 18 2.5014C18 2.7775 17.7762 3.00133 17.5001 3.00133H0.499934C0.223828 3.00133 0 2.7775 0 2.5014Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 2.5014C0 2.22529 0.223828 2.00146 0.499934 2.00146H17.5001C17.7762 2.00146 18 2.22529 18 2.5014C18 2.7775 17.7762 3.00133 17.5001 3.00133H0.499934C0.223828 3.00133 0 2.7775 0 2.5014Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.499934 3.00146H17.5001V1.00146H0.499934V3.00146ZM17.5001 2.00133H0.499934V4.00133H17.5001V2.00133ZM0.499934 2.00133C0.776113 2.00133 1 2.22522 1 2.5014H-1C-1 3.32979 -0.328457 4.00133 0.499934 4.00133V2.00133ZM17 2.5014C17 2.22522 17.2239 2.00133 17.5001 2.00133V4.00133C18.3285 4.00133 19 3.32979 19 2.5014H17ZM17.5001 3.00146C17.2239 3.00146 17 2.77758 17 2.5014H19C19 1.67301 18.3285 1.00146 17.5001 1.00146V3.00146ZM0.499934 1.00146C-0.328456 1.00146 -1 1.67301 -1 2.5014H1C1 2.77758 0.776112 3.00146 0.499934 3.00146V1.00146Z",
    fill: "white",
    mask: "url(#path-4-inside-1_575_7355)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.875,
    y: 0.5,
    width: 10.25,
    height: 1.9996,
    rx: 0.999801,
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_575_7355"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.7e029fc4aee68e6e8ab6ba5ad2724e6f.svg";
export { ForwardRef as ReactComponent };